import _classCallCheck from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/inherits";
import "core-js/modules/es6.object.define-property";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import styles from './DemoModal.module.scss';

var DemoModal =
/*#__PURE__*/
function (_Component) {
  _inherits(DemoModal, _Component);

  function DemoModal() {
    _classCallCheck(this, DemoModal);

    return _possibleConstructorReturn(this, _getPrototypeOf(DemoModal).apply(this, arguments));
  }

  _createClass(DemoModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          src = _this$props.src,
          onRequestClose = _this$props.onRequestClose;
      return React.createElement(Modal, {
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        ariaHideApp: false,
        closeTimeoutMS: 300,
        overlayClassName: {
          base: styles.overlay,
          afterOpen: styles.overlayAfterOpen,
          beforeClose: styles.overlayBeforeClose
        },
        className: styles.content
      }, React.createElement("iframe", {
        title: "DemoModal",
        width: "100%",
        height: "100%",
        src: src,
        allowFullScreen: true,
        frameBorder: "0"
      }));
    }
  }]);

  return DemoModal;
}(Component);

_defineProperty(DemoModal, "propTypes", {
  src: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired
});

export default DemoModal;